import { render } from "./projectStats.vue?vue&type=template&id=556b6d45&scoped=true"
import script from "./projectStats.vue?vue&type=script&lang=js"
export * from "./projectStats.vue?vue&type=script&lang=js"

import "./projectStats.vue?vue&type=style&index=0&id=556b6d45&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556b6d45"]])

export default __exports__